export const YA_RU_ID = 49316365
export const YA_KZ_ID = 70024498
